import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/lib/queryClient';
import { AppThemeProvider } from '@/theme/ThemeProvider';
import { StepUpProvider } from '@/features/stepUp/StepUpProvider';

/**
 * App-wide providers: React Query and the app theme.
 *
 * Mobile's list is longer because it also mounts `GestureHandlerRootView`,
 * `SafeAreaProvider` and `PaperProvider` — a gesture system the browser already
 * has, insets that are a CSS `env()` here, and a Material component library this
 * app does not use (the mobile app only reached for Paper in files nothing
 * imports; the real UI is the Brand* components, which are pure tokens).
 *
 * `root` on the theme provider marks this as the one that owns <html>: it
 * writes the palette to CSS custom properties and stamps `data-theme`. Nested
 * `ImmersiveDark` providers re-point the context for their subtree only.
 */
export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AppThemeProvider root>
        <StepUpProvider>{children}</StepUpProvider>
      </AppThemeProvider>
    </QueryClientProvider>
  );
}
